const assignBox = {
  form: {
    generalForm: {
      header: 'Configurações avançadas de atribuição de motorista',
      actions: {
        saveCheckBox: 'Salvar como padrão',
      },
      formBtns: {
        btnCancel: 'Cancelar',
        btnAssign: 'Atribuir',
      },
      inputAssignBy: 'Tipo de atribuição',
      inputActualDrivers: 'Verdadeiro',
      inputVirtualDrivers: 'Virtual',
    },
    actualForm: {
      information: {
        inputOnlyDrivers: 'Ignorar turno de motorista',
        inputMaxShiftsHours: 'Máximo de horas de turnos',
        defaultCarLocation: 'Localização Padrão de Carro',
        inputMaxPrice: 'Preço Máximo',
        inputFillVirtual: 'Preencher não atribuídos com motoristas virtuais',
        inputMaxTrips: 'Máximo de viagens',
        inputAssignFairly: 'Atribuir de forma equitativa',
      },
      validations: {
        maxShifts: {
          require: 'Obrigatório',
          min: 'Pelo menos 1',
          max: 'Máximo de 24',
        },
        carLocation: {
          require: 'Obrigatório',
        },
        fillVirtual: {
          require: 'Obrigatório',
        },
        maxTrips: {
          require: 'Obrigatório',
        },
        maxPrice: {
          require: 'Obrigatório',
        },
        default: {
          require: 'Obrigatório',
        },
      },
    },
    virtualForm: {
      information: {
        inputUpTo: 'Até',
        inputDrivers: 'Motoristas',
        inputMaxSeats: 'Máximo de lugares',
        inputMaxShiftsHours: 'Máximo de horas de turnos',
        defaultCarLocation: 'Localização Padrão de Carro',
        inputAssignFairly: 'Atribuir de forma equitativa',
      },
      validations: {
        limitDrivers: {
          require: 'Obrigatório',
        },
        carLocation: {
          require: 'Obrigatório',
        },
        maxShifts: {
          require: 'Obrigatório',
          min: 'Pelo menos 1',
          max: 'Máximo de 24',
        },
        default: {
          require: 'Obrigatório',
        },
      },
    },
    errorsMessages: {
      updateCar: 'Falha na atualização da localização do carro',
    }
  },
};

export default assignBox;
